"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Platform = exports.SignupStatus = exports.Service = exports.Province = exports.BusinessRole = exports.BusinessType = exports.DocumentType = exports.ProductType = exports.ReasonNotAvailable = exports.PaymentMethod = exports.CartType = void 0;
var CartType;
(function (CartType) {
    CartType["PORTAL"] = "portal";
    CartType["SIGNUP"] = "signup";
    CartType["SHOP"] = "shop";
})(CartType = exports.CartType || (exports.CartType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CREDIT_CARD_BLACKBIRD"] = "Credit Card (Blackbird)";
    PaymentMethod["CREDIT_CARD_CHECKOUT"] = "Credit Card (Checkout)";
    PaymentMethod["EFT"] = "EFT";
    PaymentMethod["INSTANT_EFT_STITCH"] = "Instant EFT (Stitch)";
    PaymentMethod["INSTANT_EFT_BLACKBIRD"] = "Instant EFT (Blackbird)";
    PaymentMethod["PAYMENT_TERMS"] = "Payment terms";
    PaymentMethod["CARD_ON_DELIVERY"] = "Card on delivery";
    PaymentMethod["FREE"] = "Free";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var ReasonNotAvailable;
(function (ReasonNotAvailable) {
    ReasonNotAvailable["OUT_OF_STOCK"] = "out_of_stock";
    ReasonNotAvailable["PRE_ORDER_ONLY"] = "pre_order_only";
})(ReasonNotAvailable = exports.ReasonNotAvailable || (exports.ReasonNotAvailable = {}));
var ProductType;
(function (ProductType) {
    ProductType["CARD_MACHINE"] = "card_machine";
    ProductType["SIM_CARD"] = "sim_card";
    ProductType["ACCESSORY"] = "accessory";
    ProductType["POINT_OF_SALE"] = "point_of_sale";
    ProductType["SERVICE"] = "service";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var DocumentType;
(function (DocumentType) {
    DocumentType["SA_ID_NUMBER"] = "sa_id_number";
    DocumentType["FOREIGN_PASSPORT"] = "foreign_passport";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
var BusinessType;
(function (BusinessType) {
    BusinessType["SOLE_TRADER"] = "sole_trader";
    BusinessType["COMPANY"] = "company";
    BusinessType["NOT_REGISTERED"] = "not_registered";
    BusinessType["NPO"] = "npo";
    BusinessType["TRUST"] = "trust";
})(BusinessType = exports.BusinessType || (exports.BusinessType = {}));
var BusinessRole;
(function (BusinessRole) {
    BusinessRole["DIRECTOR"] = "director";
    BusinessRole["TRUSTEE"] = "trustee";
    BusinessRole["OWNER"] = "owner";
    BusinessRole["MANAGER"] = "manager";
    BusinessRole["STAFF_MEMBER"] = "staff_member";
    BusinessRole["ADMINISTRATOR"] = "administrator";
    BusinessRole["FAMILY_OR_FRIEND"] = "family_or_friend";
    BusinessRole["OTHER"] = "other";
})(BusinessRole = exports.BusinessRole || (exports.BusinessRole = {}));
var Province;
(function (Province) {
    Province["EASTERN_CAPE"] = "Eastern Cape";
    Province["FREE_STATE"] = "Free State";
    Province["GAUTENG"] = "Gauteng";
    Province["KWAZULU_NATAL"] = "KwaZulu-Natal";
    Province["LIMPOPO"] = "Limpopo";
    Province["MPUMALANGA"] = "Mpumalanga";
    Province["NORTHERN_CAPE"] = "Northern Cape";
    Province["NORTH_WEST"] = "North West";
    Province["WESTERN_CAPE"] = "Western Cape";
})(Province = exports.Province || (exports.Province = {}));
var Service;
(function (Service) {
    Service["CARD_MACHINE"] = "card_machine";
    Service["GIFT_VOUCHERS"] = "gift_vouchers";
    Service["INVOICES"] = "invoices";
    Service["PAYMENT_REQUEST"] = "payment_request";
    Service["QR"] = "qr";
    Service["READER_REGISTRATION"] = "reader_registration";
    Service["WEBSITE"] = "website";
    Service["WAITLIST"] = "waitlist";
})(Service = exports.Service || (exports.Service = {}));
var SignupStatus;
(function (SignupStatus) {
    SignupStatus["PENDING"] = "pending";
    SignupStatus["COMPLETE"] = "complete";
    SignupStatus["CANCELLED"] = "cancelled";
})(SignupStatus = exports.SignupStatus || (exports.SignupStatus = {}));
var Platform;
(function (Platform) {
    Platform["APP"] = "app";
    Platform["KHUMO"] = "khumo";
    Platform["MOBILE_WEB"] = "mobile_web";
    Platform["WEB"] = "web";
})(Platform = exports.Platform || (exports.Platform = {}));
